import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("sf_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && localStorage.getItem("sf_token")) {
      localStorage.removeItem("sf_token");
      if (!window.location.pathname.includes("login")) window.location.reload();
    }
    return Promise.reject(e);
  }
);

export const login = (username, password) => api.post("/auth/login", { username, password }).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);

export const getMeta = () => api.get("/meta").then((r) => r.data);
export const getFilters = () => api.get("/filters").then((r) => r.data);
export const getDashboard = (params) => api.get("/dashboard", { params }).then((r) => r.data);
export const getSubclasses = (params) => api.get("/dashboard/subclasses", { params }).then((r) => r.data);
export const getVelocity = (params) => api.get("/dashboard/velocity", { params }).then((r) => r.data);
export const getItems = (params) => api.get("/items", { params }).then((r) => r.data);
export const getItem = (itemNo) => api.get(`/items/${itemNo}`).then((r) => r.data);
export const bulkLookup = (body) => api.post("/bulk-lookup", body).then((r) => r.data);
export const getLeadTimes = (params) => api.get("/lead-times", { params }).then((r) => r.data);
export const setLeadTime = (body) => api.post("/lead-times", body).then((r) => r.data);
export const removeLeadTime = (itemNo) => api.delete(`/lead-times/${itemNo}`).then((r) => r.data);
export const bulkLeadTime = (body) => api.post("/lead-times/bulk", body).then((r) => r.data);
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const putSettings = (body) => api.put("/settings", body).then((r) => r.data);
export const getSnapshots = () => api.get("/snapshots").then((r) => r.data);
export const getUploads = () => api.get("/uploads").then((r) => r.data);
export const cancelUpload = (jobId) => api.post(`/upload/cancel/${jobId}`).then((r) => r.data);
export const getRecomputeStatus = (jobId) => api.get(`/recompute/status/${jobId}`).then((r) => r.data);

export const getAudit = (params) => api.get("/audit", { params }).then((r) => r.data);
export const listUsers = () => api.get("/users").then((r) => r.data);
export const createUser = (body) => api.post("/users", body).then((r) => r.data);
export const updateUser = (username, body) => api.put(`/users/${encodeURIComponent(username)}`, body).then((r) => r.data);
export const deleteUser = (username) => api.delete(`/users/${encodeURIComponent(username)}`).then((r) => r.data);
export const changePassword = (body) => api.post("/auth/change-password", body).then((r) => r.data);

export const getProcurementSummary = () => api.get("/procurement/summary").then((r) => r.data);
export const getProcurementFilters = () => api.get("/procurement/filters").then((r) => r.data);
export const getProcurementPipeline = (params) => api.get("/procurement/pipeline", { params }).then((r) => r.data);
export const getProcurementBest = (params) => api.get("/procurement/best", { params }).then((r) => r.data);
export const getItemSuppliers = (itemNo) => api.get(`/procurement/suppliers/${itemNo}`).then((r) => r.data);
export const getProcurementAvgLeadTime = (itemNo) => api.get(`/procurement/avg-lead-time/${itemNo}`).then((r) => r.data);
export const getProcurementStatus = (jobId) => api.get(`/procurement/status/${jobId}`).then((r) => r.data);
export const setProcurementWeights = (body) => api.put("/procurement/weights", body).then((r) => r.data);

export async function downloadItemsExport(params) {
  const res = await api.get("/export/items", { params, responseType: "blob" });
  triggerDownload(res.data, "inventory_advisor.xlsx");
}

export const getPreferredSuppliers = (params) => api.get("/procurement/preferred", { params }).then((r) => r.data);

export async function downloadPreferredSuppliers(params) {
  const res = await api.get("/export/preferred-suppliers", { params, responseType: "blob" });
  triggerDownload(res.data, "preferred_suppliers.xlsx");
}

export async function downloadActualLeadTimes() {
  const res = await api.get("/export/actual-lead-times", { responseType: "blob" });
  triggerDownload(res.data, "actual_lead_times.xlsx");
}

export async function downloadDashboardExport(params) {
  const res = await api.get("/export/dashboard", { params, responseType: "blob" });
  triggerDownload(res.data, "dashboard_export.xlsx");
}

export const exportUrl = (params) => {
  const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v != null && v !== "")).toString();
  return `${BASE}/export/items?${qs}`;
};

export async function downloadBulkExport(body) {
  const res = await api.post("/bulk-lookup/export", body, { responseType: "blob" });
  triggerDownload(res.data, "bulk_item_lookup.xlsx");
}

export function triggerDownload(blob, name) {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
